import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";

import { goToScene } from "../../main";

import { playerState } from "../../state/stateManager";
import Kevin from "../../actors/characters/kevin";

export default class KevinsHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(20 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.kevin = new Kevin({ x: 15 * 16, y: 9 * 16 }, "kevinsHouse");
    this.kevin.z = 4;
  }
  onInitialize(engine) {
    Resources.KevinsHouse.addToScene(this);
    console.log("marvinshouse: adding player: ", this.player);
    this.player.lastDir = "up";

    this.add(this.player);

    this.camera.zoom = 1;

    this.door = new ex.Trigger({
      pos: new ex.Vector(18 * 16, 18 * 16 + 8),
      width: 90,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 62 * 16, y: 5 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "kevin") {
        this.kevin.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();

    this.add(this.kevin);
  }
  onPostUpdate() {}
}
